import React, { forwardRef, useEffect, useRef, useState } from "react";
import { sendFormQuotes } from "../conexion/vehicles.conexion";

async function sha256Browser(value: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

/*eslint-disable */

declare const window: any;

interface CotizacionVehiculosComponentProps {
  vehiculo: any;
}

const CotizacionVehiculosComponent = forwardRef<
  HTMLDivElement,
  CotizacionVehiculosComponentProps
>(({ vehiculo }, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [formState, setFormState]: any = useState({
    nombre: "",
    apellido: "",
    correo: "",
    celular: "",
    cedula: "",
    ciudad: "",
    departamento: "",
    concesionario: {},
    sucursal: "",
    politicas1: false,
    politicas2: false,
  });
  const [departamentos, setDepartamentos] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [concesionarios, setConcesionarios] = useState([]);
  const [sucursal, setSucursal] = useState([]);
  const [modelos, setModelos] = useState([
    {
      nombremodelo: "IONIQ 5 EV",
      nombrefamilia: "IONIQ 5",
      internal: "IONIQ 5",
      idmodelo: "a1YQC000000FK4s2AG",
      idfamilia: "a1FQC000007vHGE2A2",
    },
    {
      nombremodelo: "TUCSON 2.0L",
      nombrefamilia: "TUCSON GASOLINA",
      internal: "TUCSON XL Gasolina",
      idmodelo: "a1YQC000000FL4A2AW",
      idfamilia: "a1FQC000007vHWM2A2",
    },
    {
      nombremodelo: "TUCSON 1.6T HEV",
      nombrefamilia: "TUCSON HIBRIDA",
      internal: "TUCSON XL Híbrida",
      idmodelo: "a1YQC000001AXN72AO",
      idfamilia: "a1FQC00000U0pFl2AJ",
    },
    {
      nombremodelo: "GRAND I10 1.2L",
      nombrefamilia: "GRAND I10",
      internal: "GRAND METRO SEDÁN",
      idmodelo: "a1YQC000000FKT42AO",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "GRAND I10 HB 1.2L",
      nombrefamilia: "GRAND I10",
      internal: "GRAND METRO HATCHBACK",
      idmodelo: "a1YQC0000010Fhd2AE",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "CRETA 1.5L",
      nombrefamilia: "CRETA",
      internal: "CRETA",
      idmodelo: "a1YQC000000FLTx2AO",
      idfamilia: "a1FQC000007vHuX2AU",
    },
    {
      nombremodelo: "HB20 1.6L",
      nombrefamilia: "HB20",
      internal: "HB20 Hatchback",
      idmodelo: "a1YQC000000FKrG2AW",
      idfamilia: "a1FQC000007vI7R2AU",
    },
    {
      nombremodelo: "HB20S 1.6L",
      nombrefamilia: "HB20S",
      internal: "HB20S Sedán",
      idmodelo: "a1YQC000000FLIf2AO",
      idfamilia: "a1FQC000007vI932AE",
    },
    {
      nombremodelo: "KONA 2.0L",
      nombrefamilia: "KONA",
      internal: "KONA Gasolina",
      idmodelo: "a1YQC000000FLtl2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida",
      idmodelo: "a1YQC000000FLvN2AW",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA EV",
      nombrefamilia: "KONA",
      internal: "KONA Eléctrica",
      idmodelo: "a1YQC000000FM6f2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida N Line",
      idmodelo: "a1YQC000000eQyH2AU",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "PALISADE 3.5L",
      nombrefamilia: "PALISADE",
      internal: "PALISADE",
      idmodelo: "a1YQC000000FM9t2AG",
      idfamilia: "a1FQC000007vIH72AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA panel",
      idmodelo: "a1YQC000000FK9i2AG",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 3.5L",
      nombrefamilia: "STARIA",
      internal: "STARIA lujo",
      idmodelo: "a1YQC000000FMD72AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA pasajeros",
      idmodelo: "a1YQC000000FMEj2AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "VENUE 1.6L",
      nombrefamilia: "VENUE",
      internal: "VENUE",
      idmodelo: "a1YQC000000FMhl2AG",
      idfamilia: "a1FQC000007vILx2AM",
    },
    {
      nombremodelo: "SANTA FE 1.6T HEV",
      nombrefamilia: "SANTA FE Híbrida",
      internal: "SANTA FE Híbrida",
      idmodelo: "a1YQC0000011VPN2A2",
      idfamilia: "a1FQC00000PcdoL2AR",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(false);
  const [utmParams, setUTMParams]: any = useState({});
  const [ipAddress, setIPAddress] = useState("");
  const [error, setError] = React.useState({
    nombre: "",
    apellido: "",
    correo: "",
    celular: "",
    cedula: "",
    ciudad: "",
    concesionario: "",
  }); // Reemplaza todo el bloque "const concesionariosData: any = [...]" por esto:
  const [concesionariosData, setConcesionariosData] = useState<any[]>([]);
  const reff = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const fetchConcesionariosData = async () => {
      try {
        const response = await fetch(
          "https://manager.hyundaicolombia.co/api/concessionaire-cols?populate[concessionaires][populate][headquarters][populate][doty][populate]=*"
        );
        const json = await response.json();

        const transformedData = json.data.flatMap((region: any) =>
          region.concessionaires.flatMap((cons: any) =>
            cons.headquarters.map((hq: any) => ({
              CONCESIONARIO: cons.concessionaire || "",
              webform_name: hq.webform_name || "",
              DEPARTAMENTO: region.department || "",
              CIUDAD: region.city || "",
              "VITRINA (EXPOSICIÓN)": hq.headquarter || "",
              COD_VITRINA_EXPOSICION: hq.headquarters_cod || "",
              NIT: hq.nit || "",
              "ID Dealers": hq.dealer_id || "",
              "ID sucursales": hq.branch_id || "",
              "TIPO DE VEHICULOS": hq.vehicle_type || "",
              Department_Code_And_Name: region.region || "",
              City: region.municipality || "",
            }))
          )
        );

        setConcesionariosData(transformedData);
        console.log("✅ Concesionarios cargados:", transformedData.length);
      } catch (error) {
        console.error("Error al obtener concesionarios:", error);
      }
    };

    fetchConcesionariosData();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else if (entry.boundingClientRect.top > 0) {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (reff.current) {
      observer.observe(reff.current);
    }

    return () => {
      if (reff.current) {
        observer.unobserve(reff.current);
      }
    };
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#cotizacion") {
      const element = document.getElementById("cotizacion");
      if (element) {
        const offsetTop = element.offsetTop - 120;
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    }
  }, []);

  /* useEffect(() => {
    const fetchDepartamentos = async () => {
      try {
        const response = await fetch(
          `https://gateway.hyundaicolombia.co/regiones`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              pais: "Colombia",
            }),
          }
        );
        const data = await response.json();
        //console.log("Departamentos: ", data.data);
        setDepartamentos(data.data);
      } catch (error) {
        console.error("Error fetching departamentos: ", error);
      }
    };

    fetchDepartamentos();
  }, []); */

  useEffect(() => {
    // Validar y obtener los parámetros UTM
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const utms: any = {};
      [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
      ].forEach((key) => {
        if (urlParams.has(key)) {
          utms[key] = urlParams.get(key);
        }
      });
      setUTMParams(utms);
      //console.log("UTM Parameters:", utms);
    } catch (error) {
      console.error("Error al procesar las UTM:", error);
    }

    // Obtener la IP del usuario
    const fetchIP = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json"); // Alternativa confiable
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
        const data = await response.json();
        setIPAddress(data.ip);
        //console.log("IP Address:", data.ip);
      } catch (error) {
        console.error("Error obteniendo la IP:", error);
      }
    };
    fetchIP();
  }, []);

  const normalize = (text: string) =>
    text
      ?.toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;

    // Para checkbox
    const checked =
      type === "checkbox" ? (e.target as HTMLInputElement).checked : undefined;

    setFormState((prevState: any) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "departamento") {
      // 🧹 Limpia dependencias al cambiar de departamento
      setFormState((prev: any) => ({
        ...prev,
        ciudad: "",
        concesionario: {},
        sucursal: "",
      }));
      setCiudades([]);
      setConcesionarios([]);
      setSucursal([]);
      fetchCiudades(value);
    } else if (name === "ciudad") {
      // 🧹 Limpia concesionarios y sucursales al cambiar de ciudad
      setFormState((prev: any) => ({
        ...prev,
        concesionario: {},
        sucursal: "",
      }));
      setConcesionarios([]);
      setSucursal([]);
      fetchConcesionarios(value);
      setFormState((prevState: any) => ({
        ...prevState,
        departamento: concesionariosData.find(
          (e: any) => e.CIUDAD?.toUpperCase() === value?.toUpperCase()
        )?.Department_Code_And_Name,
      }));
    } else if (name === "concesionario") {
      fetchSucursal(JSON.parse(value));
    }
  };

  const fetchCiudades = async (departamento: string) => {
    try {
      const response = await fetch(
        `https://gateway.hyundaicolombia.co/provincias`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            region: departamento,
          }),
        }
      );
      const data = await response.json();
      //console.log("Ciudades: ", data.data);
      setCiudades(data.data); // Actualiza el estado con los concesionarios obtenidos
      setConcesionarios([]); // limpia antes de aplicar nuevo filtro
    } catch (error) {
      console.error("Error fetching concesionarios: ", error);
    }
  };

  /* const fetchConcesionarios = async (ciudad: string) => {
    try {
      setConcesionarios([]); // limpia antes de aplicar nuevo filtro
      const filtered: any = concesionariosData
        ?.filter((e: any) => e.CIUDAD?.toUpperCase() === ciudad?.toUpperCase())
        // Agrupar por NIT (evita concesionarios duplicados por tener varias vitrinas)
        .reduce((acc: any[], curr: any) => {
          if (!acc.some((c) => c.NIT === curr.NIT)) acc.push(curr);
          return acc;
        }, []);

      setConcesionarios(filtered);
    } catch (error) {
      console.error("Error filtrando concesionarios:", error);
    }
  }; */

  const fetchConcesionarios = async (ciudad: string) => {
    try {
      // 🧹 Limpia primero el estado de concesionarios
      setConcesionarios([]);

      // Espera a que React procese la limpieza antes de continuar
      await new Promise((resolve) => setTimeout(resolve, 0));

      // Filtra los concesionarios que pertenecen a la ciudad seleccionada
      const filtered: any = concesionariosData.filter(
        (e: any) => e.CIUDAD?.toUpperCase() === ciudad?.toUpperCase()
      );

      // Actualiza solo con los concesionarios válidos
      setConcesionarios(filtered);
    } catch (error) {
      console.error("Error filtrando concesionarios:", error);
    }
  };

  const fetchSucursal = async (concesionario: any) => {
    try {
      const sucursales: any = concesionariosData.filter(
        (e: any) =>
          e.NIT === concesionario.NIT &&
          e.CIUDAD?.toUpperCase() === formState?.ciudad?.toUpperCase()
      );

      setSucursal(sucursales);

      setFormState((prevState: any) => ({
        ...prevState,
        concesionario,
        sucursal: sucursales[0]?.COD_VITRINA_EXPOSICION || "",
      }));
    } catch (error) {
      console.error("Error obteniendo sucursales:", error);
    }
  };

  const sendCotizacion = async () => {
    setLoading(true);

    const dataLayerEvent: any = {
      event: "info_request_view",
      comp_product: {
        vehicle_type: "Car",
        brand: "Hyundai",
        model: `${
          modelos.find((e: any) => e?.internal === vehiculo?.title)
            ?.nombremodelo
        }`,
      },
    };

    if (window.dataLayer) {
      window.dataLayer.push(dataLayerEvent);
    }

    // 🔹 Base común
    const baseData = {
      user_name: formState.nombre,
      user_cc: formState.cedula,
      user_lastname: formState.apellido,
      user_email: formState.correo,
      user_phone: formState.celular,
      vehicle_model: modelos.find(
        (e: any) =>
          (e?.internal || e?.Internal)?.toLowerCase() ===
          vehiculo?.title?.toLowerCase()
      )?.idmodelo,
      vehicle_family: modelos.find(
        (e: any) =>
          (e?.internal || e?.Internal)?.toLowerCase() ===
          vehiculo?.title?.toLowerCase()
      )?.idfamilia,
      concessionaire: formState.concesionario.NIT,
      branch_office: formState.sucursal,
      region: formState.departamento,
      commune: window.location.href,
      province: concesionariosData?.find(
        (e: any) => e.CIUDAD === formState.ciudad
      )?.City,
      utm_campaign: utmParams.utm_campaign,
      utm_medium: utmParams.utm_medium,
      utm_source: utmParams.utm_source,
      user_ip: ipAddress,
      model: modelos.find(
        (e: any) =>
          (e?.internal || e?.Internal)?.toLowerCase() ===
          vehiculo?.title?.toLowerCase()
      )?.nombremodelo,
      family: modelos.find(
        (e: any) =>
          (e?.internal || e?.Internal)?.toLowerCase() ===
          vehiculo?.title?.toLowerCase()
      )?.nombrefamilia,
      concession: concesionariosData?.find(
        (e: any) =>
          e.NIT === formState.concesionario.NIT && e.CIUDAD === formState.ciudad
      )?.CONCESIONARIO,
      exposition_cod: formState.sucursal,
      exposition: concesionariosData.find(
        (e: any) =>
          e.NIT === formState.concesionario.NIT && e.CIUDAD === formState.ciudad
      )?.["VITRINA (EXPOSICIÓN)"],
    };

    const baseBody = {
      marca: "Hyundai_Colombia",
      origen: "Web marca",
      nombre: formState.nombre,
      numeroDocumento: formState.cedula,
      lastName: formState.apellido,
      email: formState.correo,
      telefono: formState.celular,
      modelo: baseData.vehicle_model,
      familia: baseData.vehicle_family,
      concesionario: formState.concesionario.NIT,
      exposicion: formState.sucursal,
      region: formState.departamento,
      comuna: baseData.province,
      provincia: baseData.province,
      tipoConsulta: "VT",
      areaConsulta: "VT_Cotización",
      utm_campaign: utmParams.utm_campaign,
      utm_medium: utmParams.utm_medium,
      utm_source: utmParams.utm_source,
      gdprMarca: true,
      tratamientoDatos: true,
      legalTratamientoDatos: "Acepto la política de tratamiento de datos ",
      LegalTransferenciaDatos:
        "Autorizo la transferencia y transmisión nacional e internacional de mis datos...",
      legalComunicaciones:
        "Acepto recibir ofertas, promociones, invitaciones y publicidad...",
      ip: ipAddress,
      gdprConcesionario: true,
      gdprDealer: true,
      suborigin: "233",
    };

    try {
      // 🔹 1️⃣ PRIMER envío de sendFormQuotes (ANTES del fetch)
      await sendFormQuotes({
        data: {
          ...baseData,
          quote_area: "VT_Cotización_Antes_SF",
          sf_state: "pending",
        },
      });

      // 🔹 2️⃣ Envío al endpoint create-lead
      const response = await fetch(
        `https://gateway.hyundaicolombia.co/create-lead`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify([baseBody]),
        }
      );

      const dataLayerEvent2: any = {
        event: "info_request_steps",
        comp_product: {
          vehicle_type: "Car",
          brand: "Hyundai",
          model: `${
            modelos.find(
              (e: any) =>
                (e?.internal || e?.Internal)?.toLowerCase() ===
                vehiculo?.title?.toLowerCase()
            )?.nombremodelo
          }`,
          step: "1/1",
        },
      };

      if (window.dataLayer) {
        window.dataLayer.push(dataLayerEvent2);
      }

      const data = await response.json();

      setLoading(false);
      setResult(true);

      // 🔹 3️⃣ SEGUNDO envío de sendFormQuotes (DESPUÉS del fetch)
      await sendFormQuotes({
        data: {
          ...baseData,
          quote_area: "VT_Cotización",
          sf_state: data?.success ? `${data?.success}` : "false",
        },
      }).then(async function (res: any) {
        const dataLayerEvent3: any = {
          event: "info_request_completed",
          comp_product: {
            vehicle_type: "Car",
            brand: "Hyundai",
            model: `${
              modelos?.find(
                (e: any) =>
                  e.internal?.trim().toLowerCase() ===
                  vehiculo?.title?.trim().toLowerCase()
              )?.nombremodelo
            }`,
            dealer_name: concesionariosData.find(
              (e: any) =>
                e.NIT === formState.concesionario.NIT &&
                e.CIUDAD === formState.ciudad
            )?.CONCESIONARIO,
            name_form_sha: await sha256Browser(
              `${formState.nombre} ${formState.apellido}`
            ),
            name_form: `${formState.nombre} ${formState.apellido}`,
            phone_form_sha: await sha256Browser(formState.celular),
            phone_form: formState.celular,
            email_form_sha: await sha256Browser(formState.correo),
            email_form: formState.correo,
            status: "ok",
            id: res?.data?.data?.id,
          },
        };

        if (window.dataLayer) {
          window.dataLayer.push(dataLayerEvent3);
        }
      });
    } catch (error) {
      console.error("Error en sendCotizacion:", error);
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormState({
      nombre: "",
      apellido: "",
      correo: "",
      celular: "",
      cedula: "",
      ciudad: "",
      departamento: "",
      concesionario: "",
      sucursal: "",
      politicas1: false,
      politicas2: false,
    });
    setCiudades([]);
    setConcesionarios([]);
    setSucursal([]);
    setLoading(false);
    setResult(false);
  };

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  //console.log(formState);

  const areAllFieldsFilled = Object.entries(formState).every(([key, value]) => {
    // Función auxiliar para verificar secuencias repetitivas o consecutivas
    const isSequential = (input: string): boolean => {
      const ascending = "0123456789";
      const descending = "9876543210";
      return (
        ascending.includes(input) ||
        descending.includes(input) ||
        /^(\d)\1+$/.test(input)
      );
    };

    if (typeof value === "boolean") {
      if (key === "politicas1") {
        return value; // politicas1 debe ser verdadero
      }
      return true; // otros campos booleanos no se validan
    }
    //console.log(key, value);

    if (typeof value === "object" && value !== null) {
      if (key === "concesionario") {
        //console.log(value);
        //console.log(formState?.cedula);

        return Object.keys(value).length > 0; // concesionario debe tener claves
      }
      return true; // otros objetos no se validan
    }

    if (typeof value === "string") {
      const trimmed = value.trim();

      switch (key) {
        case "nombre":
        case "apellido":
          return trimmed !== "" && /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(trimmed);

        case "correo":
          return (
            trimmed !== "" &&
            /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(trimmed)
          );

        case "celular":
          return (
            trimmed !== "" &&
            /^3\d{9}$/.test(trimmed) && // Empieza con 3 y tiene exactamente 10 dígitos
            !/[a-zA-Z]/.test(trimmed) && // No letras
            !isSequential(trimmed)
          );

        case "cedula":
          return (
            trimmed !== "" &&
            /^\d{6,10}$/.test(trimmed) && // Solo dígitos, entre 6 y 10
            !/[a-zA-Z]/.test(trimmed) && // No letras
            !isSequential(trimmed)
          );

        case "ciudad":
          return trimmed !== "";

        default:
          return true; // Campos sin validación específica
      }
    }

    // Si el tipo no es ninguno de los anteriores
    return false;
  });

  const validateField = (name: string, value: string): string => {
    const trimmed = value.trim();

    // Función auxiliar para validar que no sea una secuencia repetitiva o consecutiva
    const isSequential = (input: string): boolean => {
      const ascending = "0123456789";
      const descending = "9876543210";
      return (
        ascending.includes(input) ||
        descending.includes(input) ||
        /^(\d)\1+$/.test(input)
      );
    };

    switch (name) {
      case "nombre":
        if (trimmed === "") return "El nombre es requerido";
        if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(trimmed))
          return "El nombre solo debe contener letras y espacios";
        return "";

      case "apellido":
        if (trimmed === "") return "El apellido es requerido";
        if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(trimmed))
          return "El apellido solo debe contener letras y espacios";
        return "";

      case "correo":
        if (trimmed === "") return "El correo es requerido";
        if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(trimmed))
          return "El correo no es válido";
        return "";

      case "celular":
        if (trimmed === "") return "El número de celular es requerido";
        if (!/^\d+$/.test(trimmed))
          return "El celular solo debe contener números";
        if (!/^3\d{9}$/.test(trimmed))
          return "El celular debe comenzar con 3 y tener exactamente 10 dígitos";
        if (isSequential(trimmed))
          return "El celular no debe ser secuencial ni repetitivo";
        return "";

      case "cedula":
        if (trimmed === "") return "La cédula es requerida";
        if (!/^\d+$/.test(trimmed))
          return "La cédula solo debe contener números";
        if (trimmed.length < 6 || trimmed.length > 10)
          return "La cédula debe tener entre 6 y 10 dígitos";
        if (isSequential(trimmed))
          return "La cédula no debe ser secuencial ni repetitiva";
        return "";

      case "ciudad":
        if (trimmed === "") return "La ciudad es requerida";
        return "";

      case "concesionario":
        if (trimmed === "") return "El concesionario es requerido";
        return "";

      default:
        return "";
    }
  };

  const handleBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Clonar el estado actual de errores
    const newErrors = { ...error };

    // Validar el campo específico
    const errorMessage = validateField(name, value);
    newErrors[name as keyof typeof error] = errorMessage;

    // Actualizar el estado de errores
    setError(newErrors);
  };

  const validateForm = () => {
    const newErrors: typeof error = {
      nombre: validateField("nombre", formState.nombre),
      apellido: validateField("apellido", formState.apellido),
      correo: validateField("correo", formState.correo),
      celular: validateField("celular", formState.celular),
      cedula: validateField("cedula", formState.cedula),
      ciudad: validateField("ciudad", formState.ciudad),
      concesionario: validateField(
        "concesionario",
        formState.concesionario.NIT
      ),
    };

    // Actualizar el estado de errores con todos los campos validados
    setError(newErrors);

    // Retornar si el formulario es válido
    return Object.values(newErrors).every((error) => error === "");
  };

  return (
    <div
      className="cotizacion-vehiculos-detail-component"
      ref={ref}
      id="cotizacion"
    >
      <div
        className={`container-cotizacion-vehiculos-detail-component ${
          isVisible ? "visible" : ""
        }`}
        ref={reff}
      >
        <div className="title-container-cotizacion-vehiculos-detail-component">
          {loading || result
            ? "Ya estás más cerca de tener tu nuevo Hyundai"
            : "¡Listo para dar el primer paso!"}
        </div>
        {!loading && !result ? (
          <>
            <div className="left-container-cotizacion-vehiculos-detail-component">
              <div className="descripcion-left-container-cotizacion-vehiculos-detail-component">
                Recibe una cotización detallada y agéndate a un Test drive ahora
                para conocer todas las oportunidades que este vehículo puede
                ofrecerte.
              </div>
              <div className="subtitle-left-container-cotizacion-vehiculos-detail-component">
                Estás cotizando tu Hyundai
              </div>
              <div className="vehiculos-left-container-cotizacion-vehiculos-detail-component">
                <div className="asset-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                  <img
                    src={`https://manager.hyundaicolombia.co/${vehiculo?.src}`}
                    alt={vehiculo?.title || "Imagen del vehículo Hyundai"}
                  />
                </div>
                <div className="info-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                  <div className="title-info-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                    {vehiculo?.title}
                  </div>
                  <div className="subtitle-info-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                    Disponible desde
                  </div>
                  <div className="precio-info-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                    {vehiculo?.precio}
                  </div>
                </div>
              </div>
              <div className="condiciones-left-container-cotizacion-vehiculos-detail-component">
                *Los valores y precios publicados son de referencia y pueden
                variar sin previo aviso.
              </div>
              <div className="condiciones-left-container-cotizacion-vehiculos-detail-component">
                *Las imágenes son ilustrativas, algunas características de los
                vehículos de las imágenes pueden variar.
              </div>
            </div>
            <div className="right-container-cotizacion-vehiculos-detail-component">
              <div className="form-right-container-cotizacion-vehiculos-detail-component form">
                <div className="input-form-right-container-cotizacion-vehiculos-detail-component">
                  <label htmlFor="nombre">Nombre*</label>
                  <input
                    type="text"
                    name="nombre"
                    value={formState.nombre}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {error.nombre && (
                    <span className="error">{"Nombre es requerido"}</span>
                  )}
                </div>
                <div className="input-form-right-container-cotizacion-vehiculos-detail-component">
                  <label htmlFor="apellido">Apellido*</label>
                  <input
                    type="text"
                    name="apellido"
                    value={formState.apellido}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {error.apellido && (
                    <span className="error">{"Apellido es requerido"}</span>
                  )}
                </div>
                <div className="input-form-right-container-cotizacion-vehiculos-detail-component">
                  <label htmlFor="correo">Correo*</label>
                  <input
                    type="text"
                    name="correo"
                    value={formState.correo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {error.correo && (
                    <span className="error">{"Correo no es válido"}</span>
                  )}
                </div>
                <div className="input-form-right-container-cotizacion-vehiculos-detail-component">
                  <label htmlFor="celular">Celular*</label>
                  <input
                    type="text"
                    name="celular"
                    value={formState.celular}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {error.celular && (
                    <span className="error">{"Celular no es válido"}</span>
                  )}
                </div>
                <div className="input-form-right-container-cotizacion-vehiculos-detail-component">
                  <label htmlFor="cedula">Cédula*</label>
                  <input
                    type="text"
                    name="cedula"
                    value={formState.cedula}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {error.cedula && (
                    <span className="error">{"Cédula no es válida"}</span>
                  )}
                </div>
                <div className="input-form-right-container-cotizacion-vehiculos-detail-component">
                  <label htmlFor="ciudad">Ciudad*</label>
                  <select
                    name="ciudad"
                    value={formState.ciudad}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Selecciona</option>
                    {(
                      Array.from(
                        new Set(
                          concesionariosData.map((item: any) => item.CIUDAD)
                        )
                      ) as string[]
                    )
                      .slice()
                      .sort((a, b) =>
                        a.localeCompare(b, "es", { sensitivity: "base" })
                      )
                      .map((ciudad) => (
                        <option key={ciudad} value={ciudad}>
                          {ciudad}
                        </option>
                      ))}
                  </select>

                  {error.ciudad && (
                    <span className="error">{"Ciudad es requerida"}</span>
                  )}
                </div>
                <div className="input-form-right-container-cotizacion-vehiculos-detail-component">
                  <label htmlFor="concesionario">Concesionario*</label>
                  <select
                    name="concesionario"
                    value={JSON.stringify(formState.concesionario || {})}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Selecciona</option>
                    {(() => {
                      const ciudad = normalize(formState.ciudad);
                      const title = normalize(vehiculo?.title);

                      // Modelos que se consideran "taxi"
                      const modelosTaxi = [
                        "GRAND METRO HATCHBACK",
                        "GRAND METRO SEDAN",
                      ];

                      // Filtramos concesionarios por ciudad
                      const concesionariosPorCiudad = concesionarios?.filter(
                        (c: any) => normalize(c.CIUDAD) === ciudad
                      );

                      if (!concesionariosPorCiudad?.length) return null;

                      // Verificamos si hay concesionarios tipo TAXI en la ciudad
                      const hayTaxis = concesionariosPorCiudad.some(
                        (c: any) =>
                          c["TIPO DE VEHICULOS"]?.toUpperCase() === "TAXI" ||
                          c["TIPO DE VEHICULOS"]?.toUpperCase() === "TAXIS"
                      );

                      // Determinamos si el vehículo actual es tipo taxi
                      const esVehiculoTaxi = modelosTaxi.includes(title);

                      // ✅ Lógica corregida:
                      // - Si el vehículo es taxi y hay taxis, mostrar solo los de taxi
                      // - Si el vehículo NO es taxi, mostrar solo los que NO son de taxi
                      const concesionariosFiltrados =
                        concesionariosPorCiudad.filter((c: any) => {
                          const tipo = c["TIPO DE VEHICULOS"]?.toUpperCase();
                          if (esVehiculoTaxi && hayTaxis)
                            return tipo === "TAXI" || tipo === "TAXIS";
                          else return tipo !== "TAXI" && tipo !== "TAXIS";
                        });

                      return concesionariosFiltrados
                        .slice()
                        .sort((a: any, b: any) =>
                          a.CONCESIONARIO.localeCompare(b.CONCESIONARIO, "es", {
                            sensitivity: "base",
                          })
                        )
                        .map((concesionario: any) => (
                          <option
                            key={concesionario.NIT}
                            value={JSON.stringify(concesionario)}
                          >
                            {concesionario.webform_name}
                          </option>
                        ));
                    })()}
                  </select>

                  {error.concesionario && (
                    <span className="error">
                      {"Concesionario es requerido"}
                    </span>
                  )}
                </div>
              </div>

              <div className="politicas-right-container-cotizacion-vehiculos-detail-component">
                <div>
                  <input
                    type="checkbox"
                    name="politicas1"
                    checked={formState.politicas1}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label htmlFor="">
                    Acepto política de datos, términos y condiciones.
                  </label>
                </div>
              </div>
              <div className="politicas-right-container-cotizacion-vehiculos-detail-component">
                <div>
                  <input
                    type="checkbox"
                    name="politicas2"
                    checked={formState.politicas2}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label htmlFor="">
                    Autorizo la transferencia y transmisión de mis datos para
                    las finalidades de publicidad a las compañías de su grupo.
                  </label>
                </div>
              </div>
              <div className="text-politicas-right-container-cotizacion-vehiculos-detail-component">
                Estamos comprometidos con tu privacidad, por ello, en Hyundai
                Colombia S.A.S. junto con nuestros aliados oficiales te
                aseguramos que utilizaremos la información que nos proporcionas
                para comunicarnos contigo acerca de nuestros productos,
                servicios, ofertas, invitaciones, encuestas, entre otras
                finalidades y contenidos relevantes para ti. Puedes darte de
                baja de estas comunicaciones en cualquier momento. Para obtener
                más información consulta nuestra
              </div>
              <div
                onClick={() => sendCotizacion()}
                className={`btn-right-container-cotizacion-vehiculos-detail-component ${
                  areAllFieldsFilled ? "active" : ""
                }`}
              >
                Cotizar
              </div>
            </div>
          </>
        ) : loading && !result ? (
          <div className="spinner">
            <div className="circle"></div>
          </div>
        ) : (
          <div className="left-container-cotizacion-vehiculos-detail-component result">
            <div className="descripcion-left-container-cotizacion-vehiculos-detail-component">
              Gracias por escogernos. Pronto un asesor se contactará contigo.
            </div>
            <div className="vehiculos-left-container-cotizacion-vehiculos-detail-component">
              <div className="asset-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                <img
                  src={`https://manager.hyundaicolombia.co/${vehiculo?.src}`}
                  alt={vehiculo?.title || "Imagen del vehículo Hyundai"}
                />
              </div>
              <div className="info-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                <div className="title-info-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                  {vehiculo?.title}
                </div>
                <div className="subtitle-info-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                  Disponible desde
                </div>
                <div className="precio-info-vehiculos-left-container-cotizacion-vehiculos-detail-component">
                  {vehiculo.precio}
                </div>
              </div>
            </div>
            <div className="condiciones-left-container-cotizacion-vehiculos-detail-component">
              *Los valores y precios publicados son de referencia y pueden
              variar sin previo aviso.
            </div>
            <div className="condiciones-left-container-cotizacion-vehiculos-detail-component">
              *Las imágenes son ilustrativas, algunas características de los
              vehículos de las imágenes pueden variar.
            </div>
            <div
              className="listo-left-container-cotizacion-vehiculos-detail-component"
              onClick={() => handleReset()}
            >
              Listo
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
export default CotizacionVehiculosComponent;
